/*
 * Drawer opened by the artist_collection block in main-product.liquid.
 *
 * Mirrors CartDrawer's open/close contract (assets/cart-drawer.js): toggle the
 * shared .active class, lock body scroll with .overflow-hidden, trap focus while
 * open and restore it to the trigger on close. The slide-in itself is the theme's
 * generic .drawer / .drawer__inner CSS, not anything defined here.
 */
class ArtistCollectionDrawer extends HTMLElement {
	constructor() {
		super();

		this.activeElement = null;
		this.inner = this.querySelector(".drawer__inner");

		this.addEventListener("keyup", (event) => {
			if (event.code === "Escape") this.close();
		});

		const overlay = this.querySelector("[data-artist-drawer-overlay]");
		if (overlay) overlay.addEventListener("click", () => this.close());

		this.querySelectorAll("[data-artist-drawer-close]").forEach((button) => {
			button.addEventListener("click", () => this.close());
		});
	}

	connectedCallback() {
		/* The drawer is rendered inside the product section, so any ancestor with a
		   transform, filter or will-change traps it in that stacking context and the
		   header paints over it -- and would also make position:fixed resolve against
		   the ancestor instead of the viewport. cart-drawer avoids this by living at
		   body level in theme.liquid; Liquid can only render us in place, so relocate
		   on connect. The flag stops the re-entrant connectedCallback appendChild
		   triggers from looping. */
		if (this.parentElement !== document.body && !this.dataset.relocated) {
			this.dataset.relocated = "true";
			document.body.appendChild(this);
		}
	}

	open(triggeredBy) {
		if (triggeredBy) this.activeElement = triggeredBy;

		/* Let the browser paint the pre-transition state before transforming,
		   otherwise the drawer jumps open instead of sliding. */
		requestAnimationFrame(() => this.classList.add("animate", "active"));

		this.addEventListener(
			"transitionend",
			() => {
				if (typeof trapFocus === "function") {
					trapFocus(this, this.inner);
				}
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden");
		if (this.activeElement) {
			this.activeElement.setAttribute("aria-expanded", "true");
		}
	}

	close() {
		this.classList.remove("active");

		if (typeof removeTrapFocus === "function") {
			removeTrapFocus(this.activeElement);
		}

		document.body.classList.remove("overflow-hidden");
		if (this.activeElement) {
			this.activeElement.setAttribute("aria-expanded", "false");
		}
	}
}

if (!customElements.get("artist-collection-drawer")) {
	customElements.define("artist-collection-drawer", ArtistCollectionDrawer);
}

document.addEventListener("click", (event) => {
	const trigger = event.target.closest("[data-artist-drawer-open]");
	if (!trigger) return;

	const drawer = document.getElementById(
		trigger.getAttribute("aria-controls")
	);
	if (drawer && typeof drawer.open === "function") drawer.open(trigger);
});
